import { CircularProgress, Dialog, Stack, Typography } from "@mui/material";
import type React from "react";
import type { AccountRequestListPageProps } from "../model";
import { AccountRequestDetailDialogContent } from "./AccountRequestDetailDialogContent";
import { AccountRequestTable } from "./AccountRequestTable";

export const AccountRequestListPage: React.FC<AccountRequestListPageProps> = (
  props,
) => {
  const { accountRequests, selectedAccountRequest, onAccountRequestSelect } =
    props;

  if (accountRequests.status === "loading") {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <CircularProgress />
      </Stack>
    );
  }
  if (accountRequests.status === "error") {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Typography variant="body2" color="error">
          エラーが発生しました
        </Typography>
        <Typography variant="caption" color="error">
          {JSON.stringify(accountRequests.error)}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={4} px={4}>
      <Dialog fullWidth maxWidth="xl" open={Boolean(selectedAccountRequest)}>
        {selectedAccountRequest && (
          <AccountRequestDetailDialogContent
            accountRequest={selectedAccountRequest}
            status={props.selectedAccountRequestApprovalStatus}
            onCloseClick={() => onAccountRequestSelect(undefined)}
            onApproveClick={(password) => {
              props.onAccountRequestApprove(
                selectedAccountRequest.id,
                password,
              );
            }}
            onRejectClick={() => {
              props.onAccountRequestReject(selectedAccountRequest.id);
            }}
          />
        )}
      </Dialog>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: "24px",
        }}
      >
        アカウント申請一覧
      </Typography>
      <AccountRequestTable
        accountRequests={accountRequests.data.accountRequests}
        onAccountRequestClick={(accountRequest) => {
          onAccountRequestSelect(accountRequest);
        }}
      />
    </Stack>
  );
};
